import { useParams } from '@gogame/screens';
import { useMemo } from 'react';

export const useChatId = () => {
  const { id } = useParams();
  return useMemo(() => {
    const num = Number(id);
    return Number.isNaN(num) ? null : num;
  }, [id]);
};
